import type { Trailer, ThemeClasses, ViewType } from "../types";
import { TrailerGridCard } from "./TrailerGridCard";
import { TrailerListRow } from "./TrailerListRow";
import { DENSE_LIST } from "../../../../shared";
import type { TFunction } from "i18next";
import { useDisableCRUD } from "../../../../../../store/admin/companiesStore";

interface TrailerListProps {
  trailers: Trailer[];
  themeClasses: ThemeClasses;
  selectedView: ViewType;
  onEdit: (trailer: Trailer) => void;
  onDetails: (trailer: Trailer) => void;
  onDeviceClick?: (trailer: Trailer) => void;
  onDelete?: (trailer: Trailer) => void;
  t: TFunction;
}

export function TrailerList({
  trailers,
  themeClasses,
  selectedView,
  onEdit,
  onDetails,
  onDeviceClick,
  onDelete,
  t,
}: TrailerListProps) {
  const disableCRUD = useDisableCRUD();
  if (trailers.length === 0) {
    return (
      <div className="flex justify-center items-center w-full h-64">
        <p className="text-gray-500 text-lg font-medium">
          {t("trailers.noTrailersFound")}
        </p>
      </div>
    );
  }

  if (selectedView === "grid") {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {trailers.map((trailer) => (
          <TrailerGridCard
            key={trailer.id}
            trailer={trailer}
            themeClasses={themeClasses}
            onEdit={onEdit}
            onDetails={onDetails}
            onDeviceClick={onDeviceClick}
            onDelete={onDelete}
            t={t}
            disableCRUD={disableCRUD}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {trailers.map((trailer) => (
        <TrailerListRow
          key={trailer.id}
          trailer={trailer}
          themeClasses={themeClasses}
          onEdit={onEdit}
          onDetails={onDetails}
          onDeviceClick={onDeviceClick}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}

